

























import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { IEmployeeWorkgroup } from '@/models';
import { ErrorManager } from '@/models/error';

// directly exposed from vuetify/types no intention to change
import { InputValidationRules } from 'vuetify/types';

export type EmployeeWorkgroupPickerType =
  | (number | IEmployeeWorkgroup)[]
  | number
  | IEmployeeWorkgroup;

export default Vue.extend({
  name: 'EmployeeWorkgroupPicker',

  props: {
    value: [Array, Number, Object] as PropType<EmployeeWorkgroupPickerType>,

    label: {
      type: String,
      default: 'Workgroups'
    },

    externalErrorMessage: {
      type: [String, Array] as PropType<string | string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any, prevVal: any) {
        if (val !== prevVal) {
          this.lazyValue = val;
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      employeeWorkGroups: 'employeeWorkgroup/getEmployeeWorkgroups'
    }),

    internalValue: {
      get(): EmployeeWorkgroupPickerType {
        return this.lazyValue;
      },
      set(val: EmployeeWorkgroupPickerType) {
        this.clearInternalError();
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    genInternalMessages(): InputValidationRules {
      if (!this.externalErrorMessage) return [];
      else if (Array.isArray(this.externalErrorMessage))
        return this.externalErrorMessage;
      else return [this.externalErrorMessage];
    },

    errorMessageList(): InputValidationRules {
      const errorList = this.genInternalMessages;
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.loading = true;
    this.fetchEmployeeWorkgroups()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchEmployeeWorkgroups: 'employeeWorkgroup/fetchEmployeeWorkgroups'
    }),

    clearInternalError() {
      this.errorMessage = '';
    }
  }
});
